import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils/cn';

/**
 * Busy indicator. The glyph is decorative so it stays `aria-hidden`, but the STATE it conveys must
 * reach assistive tech: without the live region a screen-reader user gets no signal at all that a
 * submit is in flight, since every call site renders the spinner *instead of* a leading icon and
 * leaves the button's own label unchanged (B-295).
 *
 * `label` overrides the generic "Loading" where a more specific phrase reads better.
 */
export function Spinner({ className, label }: { className?: string; label?: string }) {
  const { t } = useTranslation();
  return (
    <span role="status" className="inline-flex items-center">
      <Loader2 aria-hidden className={cn('size-4 animate-spin', className)} />
      <span className="sr-only">{label ?? t('common.loadingLabel')}</span>
    </span>
  );
}
